import type { Api } from "./api";
import type { DatenAenderung } from "./neuladen";
import { demoStellvertreter } from "./demo/laden";
import { SupabaseApi } from "./supabase-api";
import { internerBereich } from "../lib/bereich";

export * from "./api";

export type WithChanges = Api & { onDataChange(cb: (a?: DatenAenderung) => void): () => void };

/**
 * Interner Bereich (/intern, Host intern.…; Inhaber 03.11.2026): eigener Supabase-Anschluss mit eigenem Speicherschlüssel,
 * also eine eigene Sitzung neben der des Kundenportals (lib/bereich.ts). Entschieden beim Laden der Seite.
 */
export const INTERN: boolean = internerBereich();

/**
 * Supabase, sobald die Zugangsdaten gesetzt sind; sonst die Demo im Browser. Die Demo (PGlite) kommt erst per import()
 * nach (demo/laden.ts): Die App mit Supabase lädt sie nie, und das Hauptbündel bleibt ohne PGlite.
 */
function create(): { api: WithChanges; bereit: () => Promise<void> } {
  const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
  const key = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;
  if (url && key) return { api: new SupabaseApi(url, key, { intern: INTERN }), bereit: () => Promise.resolve() };
  const demo = demoStellvertreter(`${import.meta.env.BASE_URL}demo/db.tar.gz`);
  return { api: demo.api as unknown as WithChanges, bereit: () => demo.laden().then(() => undefined) };
}

const angeschlossen = create();

export const api: WithChanges = angeschlossen.api;

/**
 * Vor dem ersten Zeichnen abwarten (main.tsx): lädt im Demo-Modus den Demo-Anschluss nach, damit Seiten ihn wie bisher
 * sofort vorfinden; mit Supabase sofort erfüllt. Die Datenbank selbst (/demo/db.tar.gz) lädt die Demo erst bei der ersten Abfrage.
 */
export const apiBereit: () => Promise<void> = angeschlossen.bereit;

// Nur in der Entwicklung: Zugriff aus der Browser-Konsole zum Nachprüfen (window.__tk.api).
if (import.meta.env.DEV) (globalThis as unknown as { __tk: { api: WithChanges } }).__tk = { api };
